export const filterConsts = {
  TITLE: "Filter",
  WIDTH: "55rem",
};
